import { Track } from '../../types';

/** 클릭한 곡을 현재 재생 곡 바로 다음에 넣고 그 인덱스를 반환 */
export function insertTrackAfterCurrent(
  prev: Track[],
  track: Track,
  currentTrackId: number | undefined,
): { nextList: Track[]; nextIndex: number; wasNewlyAdded: boolean } {
  if (currentTrackId === track.id) {
    const idx = prev.findIndex((item) => item.id === track.id);
    return { nextList: prev, nextIndex: idx >= 0 ? idx : 0, wasNewlyAdded: false };
  }

  const wasNewlyAdded = !prev.some((item) => item.id === track.id);
  const withoutTrack = prev.filter((item) => item.id !== track.id);

  if (withoutTrack.length === 0) {
    return { nextList: [track], nextIndex: 0, wasNewlyAdded: true };
  }

  const currentIndex =
    currentTrackId != null ? withoutTrack.findIndex((item) => item.id === currentTrackId) : -1;

  if (currentIndex === -1) {
    return { nextList: [track, ...withoutTrack], nextIndex: 0, wasNewlyAdded };
  }

  const insertAt = currentIndex + 1;
  const nextList = [
    ...withoutTrack.slice(0, insertAt),
    track,
    ...withoutTrack.slice(insertAt),
  ];

  return { nextList, nextIndex: insertAt, wasNewlyAdded };
}
